import { Add } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDatosEquipoRadiologicoEstablecimiento, getEquiposRadiologicos, setEquipoRadiologicoData } from "../../../../../../../../../../redux/actions/resolucion";
import FormikAutocomplete from "../../../../../../../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../../../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../../../../../styled/Prevencion";


const EquipoRadiologicoSelector = ({ handleOpen }) => {
    const dispatch = useDispatch();
    const equiposRadiologicos = useSelector(
        (state) => state.resolucion.equiposRadiologicos
    );
    const idTablaRadiologicos = useSelector((state) => state.resolucion.abmEquiposRadiologicos.idTabla)

    const idDependenciaEmpleador = useSelector(
        (state) => state.resolucion.searchedEstablecimiento
    );

    return (

        <StyledResolucion.EquipoRadiologicoSelectorContainer>
            <StyledResolucion.FormikInput
                style={{
                    width: "100%",
                    alignItems: "center",
                }}
            >
                {
                    idTablaRadiologicos !== null ? (
                        <FormikTextField
                            name="equipoRadiologico"
                            label="Seleccione Equipo"
                            fullWidth
                            disabled
                        />

                    )
                        : (
                            <FormikAutocomplete
                                name="equipoRadiologico"
                                label="Seleccione el equipo"
                                fullWidth
                                options={equiposRadiologicos.data}
                                renderOption={(option) => option.nombre}
                                filterOptions={(option) => option.nombre}
                                returnProp="id"
                                getOptions={() =>
                                    dispatch(getEquiposRadiologicos(idDependenciaEmpleador))
                                }
                                callBack={(value) => {
                                    if (value) {
                                        dispatch(getDatosEquipoRadiologicoEstablecimiento(value.id)).then((res) => {
                                            dispatch(setEquipoRadiologicoData({ ...res?.value?.data, id: value.id }));
                                        })
                                    }
                                }}
                            />
                        )
                }

            </StyledResolucion.FormikInput>
            {idTablaRadiologicos === null &&
                <Tooltip title="Agregar nuevo equipo radiológico">
                    <IconButton onClick={handleOpen}>
                        <Add />
                    </IconButton>
                </Tooltip>
            }
        </StyledResolucion.EquipoRadiologicoSelectorContainer>
    )
}

export default EquipoRadiologicoSelector;